export default {"src":"/_next/static/media/zeniqWhitepaper.852e4036.svg","height":38,"width":32};